import styled from "styled-components";

export default styled.div`
  .form-control {
    border-radius: 0px;
    &:focus {
      outline: none;
      box-shadow: none;
      border-color: #ced4da;
    }
  }
`;
